import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import flags from '../../../api/flags/hooks'
import { ContactProfile } from '../../../api/contacts/types'
import { APPLICATION_SETTINGS } from '../../../common/constants'
import { companyProfileInputs } from '../../../common/forms/company/inputs'
import { companyProfileValidation } from '../../../common/forms/company/validations'
import { contactProfileInputs } from '../../../common/forms/contacts/inputs'
import { contactProfileValidation } from '../../../common/forms/contacts/validations'
import { selectContactProfilePropertyServiceFilter, selectContactProfilePropertyTypeFilter } from '../../../store/formFilters'

export const useContactProfileFormConfig = (data: ContactProfile | undefined, isContact = false) => {
    const isEdit = Boolean(data?.id)
    const hasData = data && !isEmpty(data)

    const propertyServiceId = useSelector(selectContactProfilePropertyServiceFilter)
    const propertyTypeId = useSelector(selectContactProfilePropertyTypeFilter)
    
    const { data: featureFlags } = flags.GetFeatureFlags.useQuery()

    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            lang: APPLICATION_SETTINGS.DEFAULT_LANGUAGE,
            areaUnit: APPLICATION_SETTINGS.AREA_UNIT,
        }),
        []
    )

    const defaultData = useMemo(
        () => ({
            contactProfileService: { id: propertyServiceId },
            propertyType: { id: propertyTypeId },
        }),
        [propertyServiceId, propertyTypeId]
    )

    const validationData = hasData ? data : defaultData

    const inputsFn = isContact ? contactProfileInputs : companyProfileInputs
    const validationFn = isContact ? contactProfileValidation : companyProfileValidation

    const profileInputs = useMemo(
        () => inputsFn(appSettings, propertyTypeId, isEdit, featureFlags),
        [inputsFn, appSettings, propertyTypeId, isEdit, featureFlags]
    )
    const profileValidationConfig = useMemo(
        () => validationFn(validationData, propertyTypeId, featureFlags),
        [validationFn, validationData, propertyTypeId, featureFlags]
    )

    return {
        profileInputs,
        profileValidationConfig,
    }
}
